import { render, staticRenderFns } from "./commit.vue?vue&type=template&id=23a5cd84&scoped=true"
import script from "./commit.vue?vue&type=script&lang=ts"
export * from "./commit.vue?vue&type=script&lang=ts"
import style0 from "./commit.vue?vue&type=style&index=0&id=23a5cd84&prod&lang=scss&scoped=true"
import style1 from "./commit.vue?vue&type=style&index=1&id=23a5cd84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5cd84",
  null
  
)

export default component.exports